import React from 'react';
import { useNavigate } from 'react-router-dom';
import './OrganizerLanding.css';

const OrganizerFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="organizer-footer">
      <div className="organizer-footer-container">
        <div className="organizer-footer-content">
          <div className="organizer-footer-section">
            <h3 className="organizer-footer-title">Persona Screening</h3>
            <p className="organizer-footer-description">
              Transform your screening process with AI-powered interview sessions tailored to your needs.
            </p>
          </div>

          <div className="organizer-footer-section">
            <h4 className="organizer-footer-heading">Quick Links</h4>
            <ul className="organizer-footer-links">
              <li onClick={() => navigate('/organizer')}>Home</li>
              <li onClick={() => navigate('/organizer/login')}>Login</li>
              <li onClick={() => navigate('/organizer/register')}>Sign Up</li>
            </ul>
          </div>

          <div className="organizer-footer-section">
            <h4 className="organizer-footer-heading">Personas</h4>
            <ul className="organizer-footer-links">
              <li>Investor</li>
              <li>Founder</li>
              <li>Recruiter</li>
              <li>HR Manager</li>
              <li>Vendor</li>
            </ul>
          </div>

          <div className="organizer-footer-section">
            <h4 className="organizer-footer-heading">Contact</h4>
            <ul className="organizer-footer-links">
              <li onClick={() => navigate('/contactus')}>Contact Us</li>
              <li onClick={() => navigate('/aboutus')}>About Us</li>
            </ul>
          </div>
        </div>

        <div className="organizer-footer-bottom">
          <p>© 2025 <strong>AI EVALUATOR</strong>. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default OrganizerFooter;

